const settings = {
  bank_settlement: {
    name: 'Bank name',
    acc: {
      label: 'Account name',
      value: 'Enter account name'
    },
    branch: 'Branch name',
    transfer: 'Bank transfer',
    momo: 'Mobile money transfer',
    num: 'Account Number',
    add: 'Add account',
    edit: 'Edit account',
    title: 'Settlement bank account',
    empty_info: 'You need to set up settlement bank account for your business. This will enable us settle you when the time is due',
    modified: 'Bank details edited successfully',
    created: 'Bank details added successfully'
  },
  cashback: {
    cashback: 'Cashback',
    bname: 'Branch name',
    add: 'Add cashback',
    view: 'View cashback',
    select: 'Select branch',
    fixed: 'Has fixed bonus',
    start: 'Start amount',
    end: 'End amount',
    bonus: 'Bonus',
    empty: 'No cashbacks added. Please add cashback to any branch of your choice',
    percentage: 'Bonus percentage',
    fixed_bonus: 'Fixed bonus',
    edit: 'Edit cashback',
    delete: 'Delete branch',
    delete_msg: 'Cashback deleted successfully',
    details_title: 'Cashback details',
    created: 'Cashback created successfully',
    is_fixed:'Is fixed',
    branch:'Branch'
  },
  contact: {
    header: 'Contact person info',
    save:'Save'
  },
  account_settings: {
    current_pwd: {
      label: 'Current password',
      placeholder: 'Type in your current password'
    },
    new_pwd: {
      label: 'New password',
      placeholder: 'Type in your new password'
    },
    confirm_pwd: {
      label: 'Confirm password',
      placeholder: 'Re-type new password'
    },
    settings: 'Account settings',
    change_pwd: 'Change password'
  },
  role_management: {
    add_role: 'Add role',
    edit: 'Edit role',
    delete: 'Delete branch',
    edit_msg: 'Role modified successfully',
    success_msg: 'Role created successfully',
    delete_msg: 'Role deleted successfully',
    name: {
      name: 'Role name',
      label: 'Enter role name',
    },
    display_name: {
      name: 'Display name',
      label: 'Enter role diplay name',
    },

    page_title: 'Roles & Permissions',
    last_update: 'Last update: {{date}}',
    add: 'Create Role',
    add_title: 'Add Role',
    edit_title: 'Edit Role',
    view_details: 'View Detail',
    edit_role: 'Edit Role',
    duplicate_role: 'Duplicate Role',
    deactivate: 'Deactivate Role',
    enable: 'Activate Role',
    deactivate_confirm: 'Deactivated roles can no longer be assigned to new users. Existing assignees keep their current access.',
    enable_confirm: 'This will make this role assignable to users again.',
    empty_title: 'No roles yet',
    empty_hint: 'Create your first role to control what users can view and manage across the platform.',
    success_create: 'Role created successfully',
    success_update: 'Role updated successfully',
    success_disable: 'Role deactivated successfully',
    success_enable: 'Role activated successfully',

    stats: {
      total: 'Total Roles',
      active: 'Active Roles',
      users_assigned: 'Users Assigned'
    },

    filters: {
      search_placeholder: 'Search by role name',
      all_statuses: 'All statuses',
      active: 'Active',
      inactive: 'Disabled'
    },

    columns: {
      role_name: 'Role name',
      description: 'Description',
      users_assigned: 'Users assigned',
      status: 'Status',
      last_updated: 'Last updated'
    },

    table: {
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}'
    },

    detail: {
      page_title: 'Roles & Permissions Detail',
      status: 'Status',
      branch_access: 'Branch Access',
      users_assigned: 'Users Assigned',
      last_updated: 'Last Updated',
      role_information: 'Role Information',
      role_name: 'Role Name',
      role_description: 'Role Description',
      date_created: 'Date Created',
      created_by: 'Created By',
      notes: 'Notes',
      access_scope: 'Access Scope',
      role_level: 'Role Level',
      assigned_permissions: 'Assigned Permissions',
      permissions_assigned: '{{count}} of {{total}} assigned',
      view_all: 'View all',
      assigned_users: 'Assigned users'
    },

    form: {
      title: 'Add role information',
      role_name: { label: 'Role Name', placeholder: 'Enter role name' },
      description: { label: 'Role Description', placeholder: 'Describe what this role is for' },
      status: { label: 'Branch Access' },
      branch_access: { label: 'Branch Access', placeholder: 'Select branch' },
      role_level: {
        label: 'Role Level',
        placeholder: 'Select level',
        options: { branch: 'Branch level', regional: 'Regional level', organization: 'Organization level' }
      },
      notes: { label: 'Notes / Comments (Optional)', placeholder: 'Eg. use this role for finance team members responsible for transaction reconciliation.' }
    },

    permissions_step: {
      title: 'Select the permission this role should have across the platform',
      search_placeholder: 'Search permissions...',
      all_modules: 'Module: All',
      categories: {
        overview: 'Overview',
        transactions: 'Transactions',
        promos: 'Promotions',
        branches: 'Branches',
        pos: 'POS Devices',
        review: 'Reviews'
      }
    }
  },
  permission: {
    label: 'Role name'
  },
  business_info: {
    title: 'Business Information',
    category_id: 'Business category',
    description: {
      label: 'Business description',
      placeholder: 'Describe your business',
    },
    website: {
      label: 'Business website',
      placeholder: 'Enter your business website URL'
    },
  },
  head_office: {
    title: 'Head office address',
    country_id: 'Country',
    state_id: 'State',
    town: {
      label: 'Town',
      placeholder: 'Enter name of town',
    },
    street: {
      label: 'Street name',
      placeholder: 'Enter name of street'
    },
    building: {
      label: 'Building',
      placeholder: 'Enter name of office building'
    },
    address: {
      label: 'Address description',
      placeholder: 'Describe your address'
    },
    location_url: {
      label: 'Location URL',
      placeholder: 'Enter the google map url for your merchant office '
    }
  },
  business_logo: {
    title: 'Upload business logo',
    label: {
      1: 'We recommend your upload should be a ',
      2: 'square dimensions ',
      3: 'eg. 100px X 100px or 1080 X 1080. It must be either jpg or png'
    },
    btn_text: 'Upload file'
  },
  social_media: {
    title: 'Social media',
    btn_text: 'Add link'
  },
  branch: {
    page_title: 'Branch',
    add: 'Add Branch',
    edit: 'Edit Branch',
    delete: 'Delete Branch',
    disable: 'Disable Branch',
    enable: 'Enable Branch',
    view_details: 'View Detail',
    empty: 'No branch added. Please click add branch button to add new branch',
    empty_title: 'No branches added',
    empty_hint: 'Branches will appear here when added.',
    delete_confirm: 'This will permanently remove this branch. This action cannot be undone.',
    disable_confirm: 'Disabled branches are hidden from your active branch list until re-enabled.',
    success_disable: 'Branch disabled successfully',
    success_enable: 'Branch enabled successfully',
    last_update: 'Last update: {{date}}',

    stats: {
      total: 'Total Branches',
      active: 'Active Branches',
      inactive: 'Inactive Branches',
      active_pos: 'Active POS Devices'
    },

    filters: {
      search_placeholder: 'Search by branch name',
      all_locations: 'All locations',
      all_statuses: 'All statuses',
      search_location_placeholder: 'Search contact type',
      active: 'Active',
      inactive: 'Inactive'
    },

    table: {
      title: 'Branch management',
      header: {
        location: 'Location',
        name: 'Branch name',
        url: 'Location URL',
        manager: 'Branch Manager',
        contact: 'Contact',
        pos_devices: 'POS Devices',
        status: 'Status'
      },
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}'
    },

    form: {
      name: {
        placeholder: 'Enter branch name'
      },
      state_id: {
        label: 'State / Region',
        placeholder: 'Select State / Region'
      },
      town: {
        label: 'City',
        placeholder: 'Enter city'
      },
      location: {
        label: 'Location',
        placeholder: 'Enter branch location'
      },
      address: {
        label: 'Branch Address',
        placeholder: 'Enter full branch address'
      },
      landmark: {
        label: 'Landmark (Optional)',
        placeholder: 'Enter landmark'
      },
      google_map_url: {
        label: 'Location URL (Optional)',
        placeholder: 'https://...'
      },
      phone: {
        label: 'Phone Number'
      },
      alternate_phone: {
        label: 'Alternate Phone (Optional)'
      },
      email: {
        label: 'Branch Email',
        placeholder: 'Enter branch email address'
      },
      branch_manager_id: {
        label: 'Branch Manager',
        placeholder: 'Select Contact Person'
      },
      contact_person_id: {
        label: 'Contact Person',
        placeholder: 'Select Contact Person'
      },
      opens_at: {
        label: 'Opening time',
      },
      closes_at: {
        label: 'Closing time',
      },
      success: 'Branch created successfully',
      edit_success: 'Branch updated successfully',
      delete_success: 'Branch deleted successfully'
    }
  },
  user_management: {
    table_title: 'User management',
    page_title: 'Users',
    empty: 'No team members added. Please add team members and set their roles',
    empty_title: 'No users added',
    empty_hint: 'Team members will appear here when added.',
    add: 'Add team member',
    add_account: 'Add member',
    add_title: 'Create a user',
    edit: 'Edit {{firstname}}\'s details',
    edit_title: 'Edit user',
    roles: 'Roles',
    last_update: 'Last update: {{date}}',
    view_details: 'View Detail',
    edit_user: 'Edit User',
    assign_role: 'Assign Role',
    reset_password: 'Reset Password',
    deactivate: 'Deactivate User',
    enable: 'Enable User',
    disable_confirm: 'Disabling this account will revoke the user\'s access immediately. You can enable the account again at any time.',
    enable_confirm: 'This will restore this user\'s access to the Merchant Hub.',
    reset_password_confirm: 'This will send a password reset link to the user\'s email address.',
    success_create: 'User created successfully',
    success_update: 'User updated successfully',
    success_disable: 'User disabled successfully',
    success_enable: 'User enabled successfully',
    success_reset_password: 'Password reset link sent successfully',
    success_assign_role: 'Role assigned successfully',
    copied: 'Email copied to clipboard',

    filters: {
      search_placeholder: 'Search user by name',
      all_branches: 'All branches',
      all_statuses: 'All statuses',
      active: 'Active',
      inactive: 'Inactive'
    },

    table: {
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}'
    },

    columns: {
      user: 'User',
      email: 'Email Address',
      branch: 'Branch',
      phone: 'Phone Number'
    },

    assign_role_modal: {
      title: 'Assign Role',
      current_role: 'Current Role'
    },

    detail: {
      user_detail: 'User Detail',
      personal_information: 'Personal Information',
      role_access: 'Role & Access',
      status: 'Status',
      role: 'Role',
      assigned_branch: 'Assigned Branch',
      last_login: 'Last login',
      full_name: 'Full Name',
      email: 'Email',
      phone_number: 'Phone Number',
      employee_id: 'Employee ID',
      gender: 'Gender',
      account_created: 'Account Created',
      current_role: 'Current Role',
      assigned_permissions: 'Assigned Permissions',
      branch: 'Branch'
    },

    form: {
      firstname: {
        label: 'Firstname',
        placeholder: 'Enter your firstname'
      },
      lastname: {
        label: 'Lastname',
        placeholder: 'Enter your lastname'
      },
      phone: {
        label: 'Phone number',
        placeholder: 'Enter your phone number'
      },
      email: {
        label: 'Email address',
        placeholder: 'Enter your email address'
      },
      first_name: { label: 'First Name', placeholder: 'Enter First Name' },
      last_name: { label: 'Last Name', placeholder: 'Enter Last Name' },
      work_email: { label: 'Email', placeholder: 'example@company.com' },
      job_title: { label: 'Job Title', placeholder: 'Enter Job Title' },
      assign_role: { label: 'Assign Role', placeholder: 'Select Role' },
      assign_branch: { label: 'Assign Branch', placeholder: 'Select Branch' },
      success: 'User created successfully',
      mod_success: 'User created successfully',
      ban: {
        text: 'Block',
        prompt: 'Do you want to block {{fullname}}?',
        successMsg: '{{fullname}} blocked successfully',
        title: 'Block {{fullname}}'
      },
      activate: {
        text: 'Activate',
        prompt: 'Do you want to activate {{fullname}}?',
        successMsg: '{{fullname}} activated successfully',
        title: 'Activate {{fullname}}'
      }
    }
  },
  schedules: {
    table: {
      day: 'Promo days',
      from: 'Promo start time',
      to: 'Promo end time',
    }
  },
  hub: {
    title: 'Settings',
    business: {
      title: 'Business & Organization',
      description: 'Manage business details, contacts, branches and devices',
      items: {
        info: 'Business information',
        contact: 'Contact persons',
        branches: 'Branches',
        pos: 'POS Management'
      }
    },
    team: {
      title: 'Team & Access',
      description: 'Manage users, roles and permissions for your team',
      items: {
        users: 'User Management',
        roles: 'Role Management',
        permissions: 'Permission Management',
        activity: 'Access Activity'
      }
    },
    account: {
      title: 'Account & Security',
      description: 'Manage your account details and login security',
      items: {
        profile: 'My account',
        password: 'Password & Security',
        loginPolicy: 'Login & Security Policies',
        twoFactor: 'Two-Factor Authentication',
        sessions: 'Session Management'
      }
    },
    quick_links: {
      title: 'Quick Links',
      branch: {
        title: 'Create Branch',
        description: 'Create a new branch for your business',
        btn: 'Create Branch'
      },
      pos: {
        title: 'Add POS',
        description: 'Register a new POS device and assign to branch',
        btn: 'Create POS'
      },
      user: {
        title: 'Invite User',
        description: 'Invite a new team member and assign role',
        btn: 'Create User'
      },
      role: {
        title: 'Create Role',
        description: 'Create a new role and define its responsibilities',
        btn: 'Create Role'
      },
      account: {
        title: 'Manage Account',
        description: 'Update account details or reset password',
        btn: 'Manage Account'
      }
    }
  },
  team_access: {
    title: 'Team & Access',
    users: {
      title: 'Users',
      description: 'Manage your team members.',
      items: {
        management: 'User Management',
        invite: 'Invite Users',
        status: 'User Status',
        activity: 'User Activity'
      }
    },
    roles: {
      title: 'Roles & Permissions',
      description: 'Manage roles and access permissions.',
      items: {
        roles: 'Role Management',
        permissions: 'Permission Management',
        assignment: 'Role Assignment',
        activity: 'Access Activity'
      }
    }
  },
  account_security: {
    title: 'Account & Security',
    description: 'Manage your profile information and update your password.',
    my_account: {
      title: 'My Account',
      description: 'View and manage your profile information.',
      fields: {
        full_name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        job_title: 'Job Title',
        language: 'Preferred Language',
        timezone: 'Time Zone'
      }
    },
    edit_profile: {
      title: 'Edit Profile',
      button: 'Edit Profile',
      job_title: 'Job Title / Role',
      role: 'Role',
      success: 'Profile updated successfully',
      fill_all: 'Please fill all fields'
    },
    change_password: {
      description: 'Update your password to keep your account secure.'
    },
    logout: 'Log out',
    delete_account: {
      title: 'Delete account',
      confirm: 'Delete account',
      confirmation: 'This will permanently delete your ReachAfrika account and remove access to all merchant services. This action can\'t be undone.',
      not_available: 'Account deletion isn\'t available yet. Please contact support for help.'
    }
  },
  business_organization: {
    title: 'Business & Organization',
    description: 'Manage your business details, contacts, branches and POS devices',
    view_branches: 'View Branches',
    view_pos: 'View POS',
    more_branches: 'more branches',
    more_pos: 'more devices',
    edit_title: 'Edit Business Information',
    edit_success: 'Business information updated successfully',
    business_info: {
      title: 'Business info'
    },
    fields: {
      name: 'Business Name',
      merchant_id: 'Merchant ID',
      registration_number: 'Business Registration No.',
      tax_id: 'Tax ID (TIN)',
      category: 'Business category',
      website: 'Website',
      country: 'Country',
      currency: 'Currency',
      address: 'Business Address',
      description: 'Description',
      business_email: 'Business Email',
      phone: 'Phone Number',
      alternate_phone: 'Alternate Phone',
      city: 'City',
      postal_code: 'Postal Code',
      timezone: 'Time Zone'
    },
    contact_person: {
      title: 'Contact Person',
      page_title: 'Contact Persons',
      manage: 'Manage Contacts',
      primary_contact: 'Primary contact',
      empty: 'No contact person added',
      empty_hint: 'Add a contact person to see their details here.',
      search_placeholder: 'Search by contact...',
      add: 'Add Contact',
      add_title: 'Add Contact Person',
      edit_title: 'Edit Contact Person',
      success_create: 'Contact person added successfully',
      success_update: 'Contact person updated successfully',
      success_disable: 'Contact person disabled successfully',
      success_enable: 'Contact person enabled successfully',
      success_delete: 'Contact person deleted successfully',
      view_details: 'View Detail',
      edit: 'Edit Contact',
      disable: 'Disable Contact',
      enable: 'Enable Contact',
      delete: 'Delete Contact',
      disable_confirm: 'This will disable this contact person and remove their access to the Merchant Hub.',
      enable_confirm: 'This will re-enable this contact person and restore their access to the Merchant Hub.',
      delete_confirm: 'This will permanently remove this contact person. This action cannot be undone.',
      last_update: 'Last update: {{date}}',
      drawer_title: 'Contact Person Detail',
      deactivate: 'Deactivate',
      columns: {
        name: 'Contact Person',
        type: 'Contact Type',
        phone: 'Phone Number',
        email: 'Email Address'
      },
      filters: {
        search_placeholder: 'Search by contact name',
        all_types: 'All Contact Type',
        all_statuses: 'All Statuses',
        active: 'Active',
        inactive: 'Inactive'
      },
      table: {
        selected: '{{count}} of {{total}} row(s) selected.',
        page_of: 'Page {{page}} of {{total}}'
      },
      types: {
        primary: 'Primary contact',
        general: 'General inquiries',
        feedback: 'Feedback contact'
      },
      form: {
        first_name: { label: 'First Name', placeholder: 'Enter first name' },
        last_name: { label: 'Last Name', placeholder: 'Enter last name' },
        email: { label: 'Email', placeholder: 'example@company.com' },
        position: { label: 'Position', placeholder: 'Enter position of contact person' },
        contact_type: { label: 'Contact Type', placeholder: 'Select contact type' },
        phone: { label: 'Phone Number' }
      }
    },
    branches: {
      title: 'Branches',
      total: 'Total Branches',
      active: 'Active Branches',
      inactive: 'Inactive Branches',
      empty: 'No branches added',
      empty_hint: 'Add a branch to see it listed here.'
    },
    pos: {
      title: 'POS Management',
      total: 'Total POS Devices',
      active: 'Active Devices',
      inactive: 'Inactive Devices',
      empty: 'No POS devices added',
      empty_hint: 'Register a POS device to see it listed here.'
    },
    quick_actions: {
      title: 'Quick Actions',
      edit_business: {
        title: 'Edit Business Info',
        description: 'Update your business details'
      },
      edit_contact: {
        title: 'Edit Contact Person',
        description: 'Update your contact details'
      },
      create_branch: {
        title: 'Create Branch',
        description: 'Add a new branch location'
      },
      add_pos: {
        title: 'Add POS',
        description: 'Register a new POS device'
      }
    }
  },
  nav: {
    business: 'Business info',
    bank: 'Settlement info',
    contact: 'Contact person',
    user: 'User management',
    pos: 'POS management',
    role: 'Role managment',
    permission: 'Permission management',
    settings: 'Account settings',
    branches: 'Branches',
    categories: 'Categories',
    schedules: 'Schedules',
    payment_method: 'Payment Method',
  }
};

export default settings;